// Handles form validation for subscription options
class SubscriptionValidator {
  constructor(form) {
    this.form = form;
    this.addToCartBtn = form.querySelector('.product-form__submit');
    this.selections = {
      'Is this a Gift?': 'No',  // Set default value
      'Box Preference': 'Mix it up!',  // Set default value
      'Include Christmas & Easter bombs?': 'Yes'  // Set default value
    };
    
    this.setupFormValidation();
    this.validateForm(); // Initial validation
  }

  setupFormValidation() {
    // Prevent form submission if options aren't selected
    this.form.addEventListener('submit', (e) => {
      if (!this.isValid()) {
        e.preventDefault();
        this.showValidationMessage();
      }
    });
  }

  isValid() {
    return Object.values(this.selections).every(val => val !== null && val !== '');
  }

  updateSelection(type, value) {
    this.selections[type] = value;
    this.validateForm();
    
    // Remove validation message if all options are selected
    if (this.isValid()) {
      const existingMessage = this.form.querySelector('.validation-message');
      if (existingMessage) {
        existingMessage.remove();
      }
    }
  }

  validateForm() {
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = !this.isValid();
    }
  }

  showValidationMessage() {
    const message = document.createElement('div');
    message.className = 'validation-message';
    message.textContent = 'Please select all required options before adding to cart';
    
    // Remove existing message if present
    const existingMessage = this.form.querySelector('.validation-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    this.addToCartBtn.parentNode.insertBefore(message, this.addToCartBtn);
  }
}